import React, { useState } from "react";
import { Modal } from "antd";
import "./index.scss";

const Footer: React.FC = () => {
  const [open, setOpen] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="pit-footer">
      <div className="footer-inner">
        <button className="contact-btn" onClick={showModal}>
          Botón de arrepentimiento
        </button>
      </div>
      <p className="footCopy">
         ©2026 Evonete Solutions S.A.C. Pitage | Todos los derechos reservados.
      </p>
      <Modal
        open={open}
        onCancel={handleClose}
        onOk={handleClose}
        footer={null}
        centered
        width={680}
        className="arrepentimiento-modal"
        title={
          <div className="arrepentimiento-title">
            Ejercé tu derecho de arrepentimiento aquí.
          </div>
        }
      >
        <div className="arrepentimiento-content">
          <p className="paragraph">
            Conforme a la normativa vigente en materia de protección al consumidor, tienes el derecho de anular la aceptación del crédito solicitado a través de este medio, en un plazo de diez (10) días corridos desde la contratación, sin ningún costo ni penalización adicional.
          </p>
          <p className="paragraph">
            Para ejercer este derecho, rellena el formulario disponible en esta área. La solicitud será registrada y confirmada por correo electrónico.
          </p>
          <p className="paragraph">
            En caso de que el crédito ya hubiera sido entregado, la anulación estará sujeta a la devolución previa del importe percibido, según los términos y condiciones que apliquen.
          </p>
          <p className="paragraph">
            La anulación no te libera de devolver los montos realmente desembolsados ni los cargos legalmente establecidos hasta la fecha de la cancelación.
          </p>

          <div className="section-title">Para hacerlo, sigue estos pasos:</div>

          <ol className="step-list">
            <li>
              <span className="step-text">Envía un correo a </span>
              <span className="email">xxx</span>
            </li>
            <li>
              <span className="step-text">Usa como asunto: </span>
              <span className="highlight">ARREPENTIMIENTO + tu número de DNI</span>
            </li>
            <li>
              <span className="step-text">Incluye en el contenido:</span>
              <ul className="sub-list">
                <li>DNI (obligatorio)</li>
                <li>Correo electrónico (obligatorio)</li>
                <li>Número de teléfono (obligatorio)</li>
              </ul>
            </li>
          </ol>

          <p className="paragraph">
            Después de recibir tu mensaje, nuestro equipo te indicará los datos necesarios para realizar la devolución del monto correspondiente.
          </p>

          <p className="important">
            <span className="important-label">Importante:</span> la cancelación se tramitará solo cuando hayamos recibido la devolución.
          </p>

          <div className="action-row">
            <button className="confirm-btn" onClick={handleClose}>
              Entendido
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Footer;
